import { call } from 'redux-saga/effects';
import { requestActivePanelWhiteboardDataSaga } from 'features/content-whiteboard/sagas/requestActivePanelWhiteboardDataSaga';

export function* onPreviewClosedSaga() {
  yield call(requestActivePanelWhiteboardDataSaga);
}
